import { get, round } from 'lodash';
import { SET_TAX_CONFIG } from '../reduxType';

import api from '../../services/api.service';
import { getToken } from '../../services/token.service';
import { generateNotification } from '../../utils/general.utils';
const { apiService, setAuthToken } = api.getInstance();

const generateConfig = () => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()?.access_token}`,
    },
  };
  return { ...config };
};

// Create tax
export const taxCreate = (payload) => async () => {
  let result;
  try {
    const { status, data } = await apiService.post(
      'tax/create',
      {
        ...payload,
      },
      generateConfig(),
    );
    generateNotification({
      type: 'success',
      response: status,
      messages: 'tax has been created',
    });
    result = Promise.resolve(data.data);
  } catch (error) {
    generateNotification({
      type: 'error',
      response: error?.response?.status,
      messages: error?.response?.data?.detail,
    });
    result = Promise.reject(error);
  }
  return result;
};

// Update tax
export const taxUpdate = (payload) => async () => {
  let result;
  try {
    const { status } = await apiService.put(
      'tax/update',
      {
        ...payload,
      },
      generateConfig(),
    );
    generateNotification({
      type: 'success',
      response: status,
      messages: 'tax has been updated.',
    });
    result = Promise.resolve(status);
  } catch (error) {
    generateNotification({
      type: 'error',
      response: error?.response?.status,
      messages: error?.response?.data?.detail,
    });
    result = Promise.reject(error);
  }
  return result;
};

// List tax
export const taxList = () => async (dispatch) => {
  dispatch({
    type: SET_TAX_CONFIG,
    payload: {
      data: {},
      loading: true,
    },
  });

  let result;
  try {
    const { status, data } = await apiService.get(`/tax/get`, generateConfig());
    if (get(data, 'data') === null) {
      dispatch({
        type: SET_TAX_CONFIG,
        payload: {
          data: {
            ppn: {
              id: null,
              tax_name: '',
              tax_rate: 0,
              use_dpp: false,
              calculation_dpp: '',
            },
            pph: {
              id: null,
              tax_name: '',
              tax_rate: 0,
              use_dpp: false,
              calculation_dpp: '',
            },
          },
          loading: false,
        },
      });
    } else {
      dispatch({
        type: SET_TAX_CONFIG,
        payload: {
          data: get(data, 'data'),
          loading: false,
        },
      });
    }
    result = Promise.resolve();
  } catch (error) {
    dispatch({
      type: SET_TAX_CONFIG,
      payload: {
        loading: false,
      },
    });
    generateNotification({
      type: 'error',
      response: error?.response?.status,
      messages: error?.response?.data?.detail,
    });
    result = Promise.reject();
  }
  return result;
};
